import { logConversationEvent } from '@/common/utils'
import {
  LocalDispatch,
  WebChatMiddlewareAction,
  WebChatMiddlewareNext,
} from '../types'

type WebchatLogState = {
  webchat: {
    userObj?: {
      id: string
      applicationId: string
      customerId: string
    }
    conversation?: string
  }
}

export const conversationEventsMiddleware =
  (
    dispatch: LocalDispatch,
    flowName?: string,
    getState: () => WebchatLogState = () => ({ webchat: {} }),
  ) =>
  () =>
  (next: WebChatMiddlewareNext) =>
  (action: WebChatMiddlewareAction) => {
    const { activity } = action.payload ?? {}

    // TODO: extract all conversation events to this middleware
    // to decouple from Vue.
    if (
      action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' &&
      activity &&
      activity.type === 'event' &&
      activity.name === 'conversation.update'
    ) {
      dispatch('sendEvent', { name: 'client.connected', value: { flowName } })
    }

    const webchatState = () => getState().webchat

    // Log conversation ID when DirectLine connection is established
    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLING' && action.payload?.conversationId) {
      const conversationId = action.payload.conversationId
      const userObj = webchatState().userObj
      logConversationEvent('directline_connect_fulfilling', conversationId, userObj)
    }

    // Log DirectLine reconnection events
    if (action.type === 'DIRECT_LINE/RECONNECT_FULFILLED' && action.payload?.conversationId) {
      const conversationId = action.payload.conversationId
      const userObj = webchatState().userObj
      logConversationEvent('directline_reconnect_fulfilled', conversationId, userObj)
    }

    // Log connection status changes
    if (action.type === 'DIRECT_LINE/UPDATE_CONNECTION_STATUS') {
      const { userObj, conversation } = webchatState()
      logConversationEvent(
        'directline_connection_status_change',
        conversation || 'unknown',
        userObj,
      )
    }

    // Log when DirectLine connection is lost/failed
    if (
      action.type === 'DIRECT_LINE/CONNECT_REJECTED' ||
      action.type === 'DIRECT_LINE/RECONNECT_REJECTED'
    ) {
      const { userObj, conversation } = webchatState()
      logConversationEvent('directline_connection_failed', conversation || 'unknown', userObj)
    }

    return next(action)
  }
